/*

RULES FOR USING DATE AND TIME IN GOALPILOT
------------------------------------------

RULE 1: Don't use JS Date() - it's broken

RULE 2: Never use Date() or moment() to get the current date/time
        Use moment.current_time()

RULE 4: No direct import of moment except here
        Import this file: import moment form '@/moment-gp.js'
        -- Use this.$moment or moment without import --

RULE 5: Never store moment objects directly inside the store
        Use moment().toVuexStore = moment().toISOString(true) / moment().format()
        Use moment().fromVuexStore in getters

        Read more: https://medium.com/dailyjs/dates-in-vuex-primitives-or-complex-objects-6e6b29ebb880

RULE 3: Timeslot Collections times are always in user timezone

*/

// TODO: Don't allow to import moment and import moment-timezone at all

/* Allow shortcuts: import moment from '@/moment-gp.js' */
import moment from './i18n/moment/moment-enhanced.js'
export default moment
